// import image from '../assets/images/team/image.png';
import { get, post } from '../tools/http';

export default {
    state: {
        team: [],
        about: {},
        supervisors: [],
    },
    mutations: {
        writeTeam: (state, items) => state.team = items,
        setAbout: (state, about) => state.about = about,
        setSupervisors: (state, supervisors) => state.supervisors = supervisors,
    },
    actions: {
        loadTeam: ctx => {
            const on_response = async () => {
                const q = '?sort[0][column]=sort&sort[0][order]=DESC';
                const team = await get('cms', `entity/select/commandRSV${q}`);
                ctx.commit('writeTeam', team.list);
            };

            setTimeout(on_response, 500);
        },
        loadSupervisors: ctx => {
            const on_response = async () => {
                // const q = '?sort[0][column]=sort&sort[0][order]=DESC';
                const resp = await get('cms', `entity/select/supervisoryBoardRSV`);
                ctx.commit('setSupervisors', resp.list.sort((a, b) => a.sort - b.sort));
            };

            setTimeout(on_response, 500);
        },
        getAbout: async ctx => {
            const about = await get('cms', 'entity/select/page',{name: 'about'});

            if (!about) return;
            ctx.commit('setAbout', about.list[0]);
        },
    },
    getters: {
        teamTopItems: state => state.team.slice(0, 6),
        teamAllItems: state => state.team.slice(0),
        about: state => state.about,
        supervisors: state => state.supervisors,
    },
};
